import React from 'react';

const LoadingIndicator = ({isShow}) => {
    if(isShow) {
      return (<div className="linear-progress">
        <div className="bar bar1"></div>
        <div className="bar bar2"></div>
      </div>)
    }
    return null;
}
export default LoadingIndicator;